export default {
  common: {
    language: 'Langue',
    logoAlt: 'Zhongze STEAM',
    cancel: 'Annuler',
  },
  chatService: {
    chatNow: {
      label: 'Discuter maintenant',
    },
    emailGate: {
      title: 'E-mail requis',
      desc: 'Veuillez saisir votre e-mail pour continuer la discussion.',
      successMessage: 'E-mail envoyé. Vous pouvez continuer à discuter.',
    },
  },
  nav: {
    home: 'Accueil',
    products: 'Produits',
    software: 'Logiciels',
    eduServices: 'Services éducatifs',
    support: 'Service et support',
    cooperation: 'Coopération éducative',
    about: 'À propos de nous',

    // Sub-menus & Mega Menu
    learningPlatform: 'Plateforme d’apprentissage Zhongze Education',
    cloudPlatform: 'Plateforme cloud Zhongze Education',
    laserSoftware: 'Logiciel dédié aux équipements laser',
    makerK12: 'Maker éducatif - Primaire et secondaire',
    archVocational: 'Maquettes architecturales - Formation professionnelle',
    cultHigherVoc: 'Design culturel et créatif - FP supérieure',
    artsUni: 'Arts et artisanat - Universités',
    afterSales: 'Service après-vente',
    faq: 'Questions fréquentes',
    download: 'Centre de téléchargement',
    companyIntro: 'Présentation de l’entreprise',
    news: 'Actualités',
    contact: 'Nous contacter',
    device: 'Équipements',
    kits: 'Kits',
    softwareService: 'Services logiciels',
    accessories: 'Accessoires',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: 'Système de kits',
    kitsAccessories: 'Accessoires pour kits',
    courses: 'Cours',
  },
  aboutPage: {
    seoTitle: 'À propos de nous - Zhongze STEAM',
    banner: {
      title: 'À propos de nous',
    },
    about: {
      title: 'À propos de nous',
      body: 'Zhongze Education a été fondée en 2015. Grâce à une coopération étroite avec Hong Kong Unicom International, nous avons développé, sur la base des cursus STEAM européens et américains, un système d’éducation maker adapté aux enfants en Chine. Par l’apprentissage socialisé et la pratique, nous aidons les enfants à repousser leurs limites et à créer des réalisations remarquables. Avec « l’éducation STEAM + l’espace maker » comme cœur, nous portons la mission de « former les créateurs de demain ». Nous nous concentrons sur l’éducation à la créativité technologique pour les enfants et adolescents de 3 à 16 ans, déployons des espaces d’innovation éducative et développons de manière autonome des produits et des cours. Autour de modules tels que le logiciel de conception, la gravure laser et la programmation, nous construisons un écosystème unique de R&D de contenus éducatifs et une boucle fermée produit. Permettre aux enfants d’acquérir, dans de vrais projets, les compétences clés pour l’avenir ! Notre vision est de devenir un acteur de référence de l’éducation à l’innovation à l’échelle internationale. Nous offrons non seulement des cours et un environnement maker, mais aussi une nouvelle façon d’apprendre. Nous croyons que chaque enfant est un innovateur de demain : penser et explorer comme un scientifique, pratiquer comme un ingénieur, créer comme un designer et apprendre la fabrication intelligente comme un maker. Qu’ils se découvrent dans l’exploration et accomplissent leur avenir par la pratique.',
    },
    intro: {
      title: 'Pourquoi nous choisir ?',
      desc: 'Devenir un acteur de référence de l’éducation à l’innovation à l’échelle internationale : offrir des cours, un environnement maker et surtout une nouvelle façon d’apprendre. Nous croyons que chaque enfant est un innovateur de demain ; qu’il se découvre dans l’exploration et accomplisse son avenir par la pratique.',
      features: {
        projectLearning:
          'Apprentissage par projets : grâce au PBL, les enfants acquièrent, dans de vrais projets, les compétences clés pour l’avenir.',
        interactiveExperiments:
          'Expériences interactives : grâce à ces activités, les enfants maîtrisent non seulement les principes scientifiques de base, mais développent aussi la résolution de problèmes, la créativité et l’esprit d’équipe.',
      },
    },
    images: {
      aboutAlt: 'À propos de Zhongze Education',
      featureIcon1Alt: 'Icône d’apprentissage par projets',
      featureIcon2Alt: 'Icône d’expériences interactives',
      introAlt: 'Pourquoi nous choisir',
    },
  },
  newsPage: {
    banner: {
      title: 'Actualités',
    },
    tabs: [
      { id: 'all', name: 'Tout' },
      { id: 'company', name: 'Actualités de l’entreprise' },
      { id: 'exhibition', name: 'Actualités salons' },
      { id: 'industry', name: 'Tendances du secteur' },
    ],
    items: [
      {
        title:
          'Henghao Laser brille à BETT UK 2025 : la technologie laser au service de l’innovation éducative',
      },
      {
        title:
          'Au cœur de l’innovation K-12 : comment les découpeuses laser CO2 stimulent l’enseignement STEAM',
      },
      {
        title:
          'Les clients de Henghao Laser présentent Light 530 à didacta Italia 2025',
      },
      {
        title:
          'Zhongze Education dévoile une nouvelle solution éducative intelligente',
      },
      {
        title:
          'Tendances de l’éducation du futur : intégration approfondie de l’IA et de l’éducation maker',
      },
    ],
  },
  newsInformationPage: {
    banner: {
      title: 'Actualités',
    },
    tabs: [
      { id: 'all', name: 'Tout' },
      { id: 'company', name: 'Actualités de l’entreprise' },
      { id: 'exhibition', name: 'Actualités salons' },
      { id: 'industry', name: 'Tendances du secteur' },
    ],
    items: [
      {
        title:
          'Zhongze Technology lance une nouvelle génération de kits de robotique éducative, ouvrant une nouvelle tendance pour l’enseignement STEM',
      },
      {
        title:
          'L’IA à l’école : comment la programmation améliore la pensée logique des élèves',
      },
      {
        title:
          'Le concours national de robotique des jeunes 2023 s’achève avec succès ; les équipes soutenues par Zhongze remportent d’excellents résultats',
      },
      {
        title:
          'Explorer l’éducation de demain : proposition de salles de classe intelligentes dans le contexte de la transformation numérique',
      },
      {
        title:
          'Zhongze Technology conclut des partenariats stratégiques avec plusieurs universités et cofonde un laboratoire conjoint d’IA',
      },
    ],
  },

  home: {
    banner: {
      item1: {
        title: 'Éducation maker',
        desc: 'Offre un espace d’expérimentation et d’exploration, favorisant le développement global des élèves',
      },
      item2: {
        title: 'Ouvrir la porte de l’intelligence',
        desc: 'Des équipements laser aux kits et cours, couvre pleinement différents besoins d’apprentissage.',
      },
      item3: {
        title: 'Kits et cours',
        desc: 'IA + éducation ISTEAM | innovation éducative : cours essentiels pour gagner en efficacité',
      },
    },
    resources: {
      title: 'Ressources pédagogiques STEM riches et complètes',
      tabs: {
        laser: {
          name: 'Découpeuse laser',
          title: 'Équipements laser',
          desc1: 'Découpeuse et graveuse laser intelligente de bureau',
          desc2:
            'Découpe haute précision│Utilisation intelligente et simple│Traitement efficace│Sûr et écologique',
        },
        software: {
          name: 'Logiciels',
          title: 'Logiciels éducatifs',
          desc1: 'Logiciel complet et multidimensionnel',
          desc2: 'Plateforme cloud | Plateforme d’apprentissage | Light Maker',
        },
        ai: {
          name: 'Assistance pédagogique intelligente (IA)',
          title: 'Assistance pédagogique intelligente',
          desc1: 'Surveillance en temps réel et alertes des équipements',
          desc2: 'Assistant pédagogique IA | Tableau de bord visuel',
        },
        kits: {
          name: 'Kits et cours',
          title: 'Kits de cours complets',
          desc1: 'Apprentissage PBL par projets',
          desc2: 'Supports pédagogiques | Pratique manuelle',
        },
      },
    },
    different: {
      title: 'Ce qui nous différencie',
      items: {
        solution: {
          title: 'Solution éducative IA',
          desc: 'Améliore l’efficacité de l’enseignement et l’expérience d’apprentissage',
        },
        course: {
          title: 'Cours de pensée créative',
          desc: 'Cours adaptés aux enfants et adolescents de 3 à 16 ans',
        },
        product: {
          title: 'Produits éducatifs d’innovation',
          desc: 'Création laser en un clic',
        },
        space: {
          title: 'Espace d’exploration maker',
          desc: 'Alliance entre innovation et praticité',
        },
      },
    },
    creative: {
      title: 'La créativité propulse, créer façonne l’avenir',
      machineDesc:
        'Machine laser intelligente de bureau pour découpe et gravure',
      lightBlue530Desc: 'Machine intelligente de découpe & gravure laser bleu',
      markM20Desc: 'Machine de marquage laser haute précision',
      light640Desc: 'Machine professionnelle de découpe & gravure laser de bureau',
    },
    innovation: {
      title: 'Comment favoriser l’apprentissage innovant ?',
      desc: 'Zhongze Education s’engage à développer des produits éducatifs d’innovation de haute qualité, dont des découpeuses laser. Ces produits soutiennent l’apprentissage pratique des élèves en sciences, technologie, ingénierie, arts et mathématiques.',
      items: {
        steam: 'STEAM',
        coding: 'Programmation',
        light530: 'Utiliser Light 530',
        robotics: 'Robotique',
      },
    },
    bottomBanner: {
      title: 'Mettre l’éducation avec l’IA en pratique',
      subtitle:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
      desc: 'Spécialisés dans les produits laser personnalisés et les services technologiques, nous aidons établissements et entreprises à intégrer【IA+éducation】',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: 'Logiciel dédié aux équipements laser  Light Maker',
      bannerDesc:
        'Logiciel professionnel pour équipements laser, simple et efficace, axé sur l’expérience de découpe et de gravure.',
      bannerImageAlt: 'Interface Light Maker',
      creationTitle: 'Simplifier la création',
      features: {
        proDesignTool: 'Outils de conception professionnels',
        highPrecisionParams: 'Réglage de paramètres haute précision',
        multiDeviceControl: 'Gestion et contrôle multi-appareils',
        assetLibrary: 'Système puissant de gestion des ressources',
      },
      intro: {
        imageAlt: 'Présentation des fonctionnalités',
        items: {
          item1: {
            title: 'Système de conception puissant et simple à utiliser',
            desc: 'Logiciel de création performant, compatible avec des conceptions de haute qualité aux formats JPG, DXF, AI, DST, PNG, BMP, TIF et SVG.',
          },
          item2: {
            title: 'Professionnalisme',
            desc: 'Fonctions de dessin professionnelles couvrant tous les besoins de création. Des conceptions complexes aux découpes simples, tout se réalise facilement.',
          },
        },
      },
      downloadTitle: 'Téléchargement du logiciel',
      downloadButton: 'Télécharger et essayer',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: 'Plateforme d’apprentissage Zhongze Education',
      bannerDescLine1:
        'La plateforme d’apprentissage Zhongze Education est un outil d’apprentissage en ligne innovant, conçu pour offrir aux élèves et aux enseignants une solution logicielle éducative complète.',
      bannerDescLine2:
        'Sur mobile comme sur ordinateur, les utilisateurs peuvent accéder à notre plateforme et l’utiliser facilement.',
      bannerImageAlt:
        'Interface de la plateforme d’apprentissage Zhongze Education',
      exploreTitle:
        'Explorer des possibilités infinies, créer un avenir brillant',
      exploreTabs: [
        { name: 'Créer' },
        { name: 'Démarrage' },
        { name: 'Apprentissage de la modélisation' },
        { name: 'Création en un clic' },
        { name: 'Génération d’images par IA' },
      ],
      tabContentAlt: 'Présentation des fonctionnalités',
      introTitle: 'Plateforme d’apprentissage innovante',
      introItems: [
        {
          title: 'Nouvelle expérience d’apprentissage efficace',
          desc: 'La plateforme d’apprentissage Zhongze Education intègre en un seul endroit l’étude des cours, la conception graphique et la découpe laser. L’interface sous forme de cartes est claire et intuitive, l’utilisation est fluide ; elle relie sans couture la conception créative et la réalisation d’objets, pour une prise en main rapide et efficace.',
        },
        {
          title: 'Intelligente et pratique, idéale pour débuter',
          desc: 'Bibliothèque intégrée riche et préréglages intelligents : création en un clic, prise en main en quelques secondes. Tutoriels guidés détaillés sur mobile pour démarrer sans stress. Surveillance en temps réel de l’état des équipements via le cloud, pour une sécurité pédagogique tout au long du processus.',
        },
      ],
      introImageAlt: 'Plateforme d’apprentissage innovante',
      galleryAlt: 'Aperçu de la plateforme',
      downloadTitle: 'Téléchargement du logiciel',
      downloadApps: [
        { name: 'Application Zhongze Education' },
        { name: 'Logiciel de conception Zhongze (PC)' },
      ],
      downloadButtonText: 'Télécharger et essayer',
    },
    cloudPlatform: {
      bannerTitle: 'Plateforme cloud Zhongze Education',
      bannerDesc:
        'Outil de gestion éducative tout-en-un, prenant en charge l’envoi et la réception des devoirs, la surveillance des équipements, les demandes de réparation et la configuration des paramètres, afin d’aider enseignants, élèves et établissements à gérer efficacement.',
      bannerImageAlt: 'Interface de la plateforme cloud Zhongze Education',
      exploreTitle: 'Simplifier la gestion pédagogique',
      exploreTabs: [
        { name: 'Créer' },
        { name: 'Démarrage' },
        { name: 'Apprentissage avancé' },
      ],
      tabContentAlt: 'Présentation des fonctionnalités',
      introTitle: 'Améliorer l’efficacité éducative',
      introItems: [
        {
          title: 'Utilisation pratique',
          desc: 'Création en un clic : bibliothèque intégrée et configuration de paramètres pour simplifier le flux. Surveillance des équipements : suivi en temps réel de l’état pour garantir le bon déroulement des activités pédagogiques.',
        },
        {
          title: 'Gestion unifiée',
          desc: 'Connexion parallèle des équipements : prise en charge de la connexion d’autres équipements de la salle maker, gestion en un clic, amélioration de l’efficacité d’administration.',
        },
        {
          title: 'Surveillance en temps réel',
          desc: 'État des équipements : suivre en temps réel le fonctionnement et demander une réparation en cas de panne. Maintenance : le système rappelle régulièrement l’entretien en fonction du temps d’utilisation et de la fréquence, prolonge la durée de vie et améliore la qualité de découpe.',
        },
      ],
      introImageAlt: 'Plateforme d’apprentissage innovante',
      galleryTitle: 'Mettre l’éducation avec l’IA en pratique',
      galleryDesc:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
    },
  },
  eduServices: {
    banner: {
      title: 'IA+éducation',
      desc: 'La solution d’enseignement numérique intelligent de Zhongze Education aide à former des talents innovants. Axée sur le développement éducatif et les besoins des élèves, elle propose des solutions d’IA pour toutes les étapes du K-12.',
      imageAlt: 'Bannière de la solution éducative',
    },
    recommended: {
      title: 'Produits recommandés',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: 'Créer un espace pédagogique polyvalent',
      tabs: {
        'teaching-assist': 'Assistance pédagogique intelligente',
        'process-optimize': 'Optimisation du processus pédagogique',
        'device-manage': 'Gestion des équipements',
      },
      tabContents: {
        'teaching-assist': {
          title: 'Assistance pédagogique intelligente',
          features: [
            '·Surveillance en temps réel et ressources des équipements',
            '·Assistant d’apprentissage intelligent par IA',
            '·Tableau de bord visuel',
          ],
        },
        'process-optimize': {
          title: 'Optimisation du processus pédagogique',
          features: [
            '·Distribution et correction des devoirs en ligne',
            '·Contrôle centralisé à distance des ressources cloud de cours',
          ],
        },
        'device-manage': {
          title: 'Gestion des équipements',
          features: [
            '·Surveillance en temps réel des équipements éducatifs',
            '·Demandes de réparation à distance des équipements',
          ],
        },
      },
      categories: [
        {
          title: 'Distribuer et corriger les devoirs en ligne',
          description:
            'Système de gestion des devoirs intelligent pour améliorer l’efficacité pédagogique',
        },
        {
          title: 'Demande de réparation à distance des équipements',
          description:
            'Service pratique de maintenance et de réparation à distance',
        },
        {
          title:
            'Contrôle centralisé à distance, simplifier le processus pédagogique',
          description:
            'Plateforme unifiée de gestion à distance pour optimiser le flux pédagogique',
        },
        {
          title: 'Ressources cloud de cours',
          description:
            'Ressources de cours et supports pédagogiques riches dans le cloud',
        },
        {
          title: 'Surveillance en temps réel des équipements éducatifs',
          description:
            'Surveillance en temps réel de l’état des équipements pour assurer le bon déroulement des cours',
        },
        {
          title: 'Assistant pédagogique intelligent IA',
          description:
            'Système d’assistance pédagogique intelligent piloté par l’IA',
        },
      ],
      solutionCards: [
        { title: 'Solution d’innovation numérique intelligente' },
        {
          title:
            'Solution de salle de classe intelligente pour primaire et secondaire',
        },
        {
          title:
            'Solution de compétences pour l’enseignement secondaire et supérieur professionnel',
        },
        { title: 'Solution de salle de classe IA pour universités' },
      ],
    },
    solutions: {
      title: 'Solution éducative tout-en-un',
      items: [
        {
          title: 'Équipements',
          description:
            'Dans le contexte d’une éducation renforcée par l’IA, les découpeuses laser Henghao s’appuient sur une plateforme cloud intelligente et s’intègrent en profondeur à la plateforme cloud d’enseignement laser de Zhongze Education. Les enseignants peuvent gérer les équipements à distance, distribuer des tâches et suivre la progression des élèves. Cette intégration améliore l’efficacité pédagogique et offre une expérience d’apprentissage plus personnalisée.',
          buttonText: 'Voir les détails →',
        },
        {
          title: 'Logiciels',
          description:
            'La plateforme Zhongze Education intègre des technologies d’IA pour offrir un apprentissage personnalisé, des outils intelligents, des expériences interactives et des ressources cloud. Elle prend en charge la gestion des cours et des devoirs, la surveillance et les alertes des équipements, ainsi que l’analyse de données. En combinaison avec la plateforme d’apprentissage Zhongze (APP/PC) et l’outil Light Maker, elle soutient l’enseignement de manière globale, optimise les ressources et favorise l’innovation, apportant un solide appui aux enseignants, élèves et établissements.',
          buttonText: 'Voir les détails →',
        },
        {
          title: 'Cours',
          description:
            'Les cours de découpe et d’innovation de Zhongze Education sont des programmes systématiques et modulaires conçus pour les jeunes, visant à susciter l’intérêt et à développer le potentiel. Ils couvrent les connaissances technologiques, la pensée innovante, la pratique par projets et les expériences scientifiques, aidant à former des talents de l’innovation pour l’avenir et à promouvoir le développement social.',
          buttonText: 'Voir les détails →',
        },
      ],
    },
    managementPlatform: {
      title: 'Plateforme de gestion pédagogique intelligente Zhongze Education',
      desc: 'Offre des parcours d’apprentissage personnalisés, des outils pédagogiques intelligents, des expériences interactives et une bibliothèque de ressources cloud. Prend en charge la gestion des cours, le suivi de la progression des élèves, les devoirs en ligne, la surveillance et les alertes en temps réel des équipements pédagogiques, l’analyse de données, etc. En intégrant des technologies d’IA, elle améliore les résultats d’enseignement et optimise l’allocation des ressources, apportant un soutien complet aux élèves, enseignants, écoles et institutions pour promouvoir ensemble le développement et l’innovation éducative.',
      items: [
        {
          title: 'Solution d’innovation numérique intelligente',
          alt: 'Solution d’innovation numérique intelligente',
        },
        {
          title:
            'Solution de salle de classe intelligente pour primaire et secondaire',
          alt: 'Solution de salle de classe intelligente pour primaire et secondaire',
        },
        {
          title:
            'Solution de compétences pour l’enseignement secondaire et supérieur professionnel',
          alt: 'Solution de compétences pour l’enseignement secondaire et supérieur professionnel',
        },
        {
          title: 'Solution de salle de classe IA pour universités',
          alt: 'Solution de salle de classe IA pour universités',
        },
      ],
      action: {
        text: 'Obtenir une solution dédiée',
        alt: 'Icône Nous contacter',
      },
    },
  },
  makerK12: {
    banner: {
      title: 'Maker éducatif — Primaire et secondaire',
    },
    intro: {
      title: 'Découpeuse laser dans l’éducation et les écoles',
      desc: 'À l’école, utiliser une découpeuse laser est sûr, sans contact et numérique, de l’idée au produit fini. Donnez vie facilement aux idées les plus originales des enfants.',
      imageAlt: 'Découpeuse laser en fabrication de maquettes architecturales',
    },
    scenesFeatured: {
      title:
        'Transformer l’apprentissage grâce à des outils éducatifs de pointe',
      desc: 'Offrir aux élèves des technologies de référence pour développer créativité, pensée critique et compétences techniques.',
    },
    scenes: {
      items: [
        {
          title: 'Offrir à chaque élève une plateforme de création laser',
          desc: 'Mettre la démarche en pratique, renforcer l’engagement des élèves et leur permettre de développer une pensée créative en classe grâce à des outils puissants.',
        },
        {
          title: 'Kits électroniques et de programmation',
          desc: 'Impliquer les élèves dans la programmation pratique, la robotique et l’intelligence artificielle grâce à des kits interactifs.',
        },
        {
          title: 'Formation professionnelle',
          desc: 'S’appuyer sur une plateforme technologique laser pour préparer des parcours professionnels et développer les compétences, s’adapter à un marché du travail en évolution et créer davantage d’opportunités.',
        },
      ],
    },
    solutions: {
      title:
        'Les maquettes architecturales sont largement utilisées dans de nombreux domaines',
      items: [
        { title: 'Écoles K-12 / districts scolaires' },
        { title: 'Organismes de formation' },
        { title: 'Laboratoires de recherche & cursus spécialisés' },
        { title: 'Espaces maker' },
        { title: 'Bibliothèques / musées d’architecture' },
        { title: 'Cours créatifs' },
      ],
    },
    bannerLeft: {
      title: 'Mettre l’éducation avec l’IA en pratique',
      subtitle:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
    },
    products: {
      tabs: [
        {
          title: 'Équipements laser',
          title1: 'L’outil de création - découpeuse laser',
          description:
            'Light530 et 640 intègrent des composants de premier ordre, un procédé de fabrication de haute qualité et des contrôles stricts. Il en résulte une machine laser puissante, performante et stable, offrant une découpe et une gravure précises, parfaitement adaptée aux besoins de création dans les scénarios éducatifs d’innovation.',
        },
        {
          title: 'Logiciels',
          title1: 'L’expert du dessin - LightMaker',
          description:
            'Offre aux élèves sécurité, vitesse, fonctions intelligentes et des conceptions technologiques parmi les plus innovantes du marché. LightMaker est compatible avec de nombreux logiciels de conception, notamment AI, PS, CorelDRAW, AutoCAD et Solidworks, et prend en charge l’importation de fichiers de haute qualité aux formats JPG, DXF, AI, DST, PNG, BMP, TIF et SVG.',
        },
        {
          title: 'Cours',
          title1: 'Enseignement diversifié - cours d’innovation',
          description:
            'Nous savons que chaque enfant est unique. Nos cours sont donc flexibles et variés, conçus pour éveiller l’intérêt et développer le potentiel de chaque élève. Le contenu couvre notamment : bases technologiques, entraînement à la pensée innovante, pratique par projets, expériences scientifiques, etc.',
        },
      ],
    },
    learning: {
      title:
        'Comment utiliser la découpeuse laser Zhongze Education en classe ?',
      teacher: {
        title: 'Enseignants',
        lines: [
          'Fabriquer des supports de cours et des accessoires pédagogiques',
          'La découpeuse laser aide les enseignants à produire efficacement des supports et accessoires de classe, et à créer des approches pédagogiques plus innovantes.',
        ],
      },
      student: {
        title: 'Élèves',
        lines: [
          'Développer des compétences pratiques',
          'En classe, la découpeuse laser accompagne les élèves dans l’apprentissage interdisciplinaire (design, ingénierie, technologie, etc.) et les aide à concrétiser leurs idées.',
        ],
      },
    },
    carousel: {
      items: [
        { alt: 'Scène de fabrication de maquettes 1' },
        { alt: 'Scène de fabrication de maquettes 2' },
        { alt: 'Scène de fabrication de maquettes 3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: 'Maquettes architecturales - Formation professionnelle',
    },
    intro: {
      title:
        'Comment une découpeuse laser est-elle utilisée pour réaliser des maquettes architecturales ?',
      desc: 'Vous pouvez utiliser la découpe et la gravure laser pour fabriquer des maquettes architecturales, y compris les plus petites pièces utilisées dans la fabrication de modèles pour l’industrie du jouet. La découpe laser permet de découper rapidement et avec précision des textiles, plastiques, bois, panneaux plaqués, MDF, PMMA, carton, papier, mousse, polystyrène, films, acrylique, etc.',
      imageAlt: 'Découpeuse laser en fabrication de maquettes architecturales',
    },
    scenesFeatured: {
      title:
        'Une force de transformation pour la fabrication de maquettes architecturales',
      desc: 'Vous aide à réaliser des prototypes miniatures précis et des maquettes architecturales de haute qualité, en restituant avec finesse vos plans créatifs。',
    },
    scenes: {
      items: [
        {
          title: 'Haute précision',
          desc: 'Les découpeuses laser peuvent découper les matériaux avec une précision extrême, avec une marge d’erreur minimale, garantissant des pièces aux dimensions exactes pour s’ajuster parfaitement aux plans de conception。',
        },
        {
          title: 'Matériaux variés',
          desc: 'Le grain naturel du bois, la transparence et la brillance de l’acrylique, ainsi que la légèreté et la malléabilité du papier peuvent tous révéler un charme unique grâce à la découpe et à la gravure laser。',
        },
        {
          title: 'Excellente gestion des formes complexes',
          desc: 'Pour les formes géométriques complexes et les détails fins courants dans les maquettes, la découpe laser les réalise facilement (courbes, structures irrégulières, etc.), offrant davantage de liberté créative。',
        },
      ],
    },
    solutions: {
      title:
        'Les maquettes architecturales sont largement utilisées dans de nombreux domaines',
      items: [
        { title: 'Éducation et recherche académique' },
        { title: 'Modélisme et industrie du jouet' },
        { title: 'Éléments décoratifs et caractéristiques architecturales' },
        { title: 'Immobilier et urbanisme' },
        { title: 'Décoration et aménagement intérieurs' },
      ],
    },
    bannerLeft: {
      title: 'Mettre l’éducation avec l’IA en pratique',
      subtitle:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
    },
    products: {
      tabs: [
        {
          title: ' Un équipement adapté',
          title1: 'Choisir un équipement adapté',
          description:
            'Les équipements laser permettent de transformer rapidement les idées des élèves en objets réels, qu’il s’agisse de maquettes, de design ou de création artistique. Du bricolage simple aux conceptions mécaniques complexes, les découpeuses et graveuses laser réalisent les tâches avec précision, permettant aux élèves d’apprendre et de progresser par la pratique. ',
        },
        {
          title: 'Concevoir soi-même',
          title1: 'Concevoir soi-même',
          description:
            'Modifier intuitivement le design et prévisualiser le résultat final. Découpez et reproduisez les détails de n’importe quel design sur divers matériaux : utilisez du texte, des logos, des images ou des photos pour améliorer vos créations. Décorez rapidement vos maquettes architecturales.',
        },
        {
          title: 'Votre marché',
          title1: 'Développer les compétences des élèves',
          description:
            'Marqueuse laser portable, idéale pour le marquage et la gravure de détails sur les maquettes architecturales. Simple d’utilisation et facile à transporter, c’est un outil indispensable pour l’enseignement de l’architecture.',
        },
      ],
    },
    learning: {
      title: 'Enseignement interdisciplinaire',
      groups: [
        {
          title: 'Maquettes miniatures',
          lines: [
            'Précis et minutieux, répond aux besoins de création miniature',
            'Restitution soignée des détails de gravure/découpe laser sur de nombreux matériaux, en supprimant les étapes fastidieuses, en gagnant en efficacité et en réduisant les erreurs manuelles。',
          ],
        },
        {
          title: 'Design d’intérieur',
          lines: [
            'Les détails du design, en une seule fois : la caméra intégrée permet de prévisualiser facilement position et dimensions, pour un rendu fidèle à l’écran. Exécute efficacement la découpe/gravure et réduit les pertes de matériau。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Scène de fabrication de maquettes architecturales 1' },
        { alt: 'Scène de fabrication de maquettes architecturales 2' },
        { alt: 'Scène de fabrication de maquettes architecturales 3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: 'Arts et artisanat - Universités',
    },
    intro: {
      title:
        'Comment utiliser les équipements laser pour fabriquer des arts et artisanat',
      desc: 'Cet équipement offre aux étudiants une plateforme pour transformer leurs idées en objets concrets, stimulant leur pensée innovante et leur créativité. Les étudiants peuvent concevoir divers modèles et œuvres uniques, comme des découpes papier au laser ou des tampons.',
      imageAlt: 'Équipements laser pour la fabrication d’arts et artisanat',
    },
    scenesFeatured: {
      title: 'Développement des compétences techniques',
      desc: 'En utilisant des découpeuses et graveuses laser, les étudiants peuvent acquérir des connaissances approfondies en science des matériaux et en procédés de fabrication, tout en renforçant leurs compétences pratiques et leur capacité à résoudre des problèmes.',
    },
    scenes: {
      items: [
        {
          title: 'Stimulation de la pensée créative',
          desc: 'Les découpeuses et graveuses laser peuvent servir à concrétiser les idées des étudiants, comme la fabrication de maquettes et d’œuvres artistiques, renforçant leur créativité.',
        },
        {
          title: 'Intégration pluridisciplinaire',
          desc: 'Les technologies de découpe et de gravure laser mobilisent des connaissances en physique, chimie, science des matériaux, informatique, etc. Dans l’enseignement supérieur, elles favorisent les croisements disciplinaires et développent des compétences transversales.',
        },
        {
          title: 'Projets d’enseignement pratique',
          desc: 'Les technologies de découpe et de gravure laser peuvent être utilisées dans des projets pratiques à l’université (formation en ingénierie, design artistique, création culturelle, etc.). Par exemple, les étudiants peuvent fabriquer des maquettes architecturales, des pièces mécaniques ou des sculptures, en combinant théorie et pratique.',
        },
      ],
    },
    solutions: {
      title:
        'Applications dans la fabrication d’objets artisanaux à l’université',
      items: [
        { title: 'Produits de vente au détail personnalisés' },
        { title: 'Personnalisation de cadeaux' },
        { title: 'Marketing saisonnier et événementiel' },
        { title: 'Bijoux et accessoires' },
        { title: 'Vêtements personnalisés' },
      ],
    },
    bannerLeft: {
      title: 'Mettre l’éducation avec l’IA en pratique',
      subtitle:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
    },
    products: {
      tabs: [
        {
          title: ' Un équipement adapté',
          title1: 'Choisir un équipement adapté',
          description:
            'En choisissant des équipements de découpe et de gravure laser adaptés, les universités peuvent fournir aux étudiants des outils avancés pour l’enseignement pratique, stimuler leur créativité, et améliorer la qualité et l’efficacité pédagogiques.',
        },
        {
          title: 'Concevoir soi-même',
          title1: 'Concevoir soi-même',
          description:
            'Modifier intuitivement le design et prévisualiser le résultat final. Gravez et reproduisez les détails de n’importe quel design sur divers matériaux : utilisez du texte, des logos, des images ou des photos pour améliorer vos créations. Les graveuses laser sont très simples à utiliser et permettent de décorer rapidement vos œuvres.',
        },
        {
          title: 'Arts et design',
          title1: 'Enseignement des filières arts et design',
          description:
            'Dans les filières d’art, de design industriel, etc., les découpeuses et graveuses laser sont largement utilisées dans les projets de cours et de fin d’études. Les étudiants peuvent transformer rapidement leurs idées en prototypes physiques et développer leurs compétences en conception de produits.',
        },
      ],
    },
    learning: {
      title: 'Faire entrer le laser à l’école',
      groups: [
        {
          title: 'Précis et efficace, gain de temps et d’effort',
          lines: [
            'Les découpeuses laser Zhongze prennent en charge l’aperçu caméra : alignement précis sans gaspillage, prise en main facile même pour les débutants。',
            'Utilisation fluide et simple : insérez le matériau et créez, ce que vous voyez est ce que vous obtenez。',
            'Création précise, optimisation de chaque plaque : gain de temps, d’effort et de matériau。',
          ],
        },
        {
          title: 'Haute puissance, gère facilement de nombreux matériaux',
          lines: [
            'Équipée d’un laser CO₂ haute puissance, elle excelle en gravure comme en découpe。',
            'Découpe et grave facilement l’acrylique, le bois, le bambou et bien d’autres matériaux, offrant un flux de création convivial aux makers et rendant la création plus simple et plus efficace。',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: 'Scène de création d’arts et artisanat 1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: 'Design culturel et créatif - FP supérieure',
    },
    intro: {
      title: 'Équipements laser dans le design culturel et créatif',
      desc: 'Les filières de design culturel et créatif en FP supérieure sont généralement équipées d’équipements avancés de découpe et de gravure laser (comme des graveuses laser), capables de répondre aux besoins d’enseignement pratique des étudiants à différents niveaux.',
      imageAlt: 'Équipements laser dans le design culturel et créatif',
    },
    scenesFeatured: {
      title: 'Ouvrir des possibilités infinies de créativité et de qualité',
      desc: 'Grâce à ses performances remarquables et à sa capacité de découpe précise, cet équipement devient un outil indispensable pour les designers culturels et créatifs.',
    },
    scenes: {
      items: [
        {
          title:
            'Découpe haute précision, restitution parfaite des détails du design',
          desc: 'Pour les motifs complexes et les formes uniques du design culturel et créatif, la découpeuse laser peut les reproduire fidèlement, garantissant que chaque détail soit restitué avec exactitude dans le produit final.',
        },
        {
          title: 'Traitement de matériaux variés',
          desc: 'Les équipements laser peuvent traiter de nombreux matériaux (bois, acrylique, cuir, métal, etc.), offrant un large éventail d’options pour la conception de produits culturels et créatifs.',
        },
        {
          title:
            'Commande intelligente, simplifie la mise en œuvre des idées créatives',
          desc: 'Les étudiants n’ont qu’à importer leurs motifs dans l’ordinateur : la découpeuse laser les reconnaît et effectue une découpe précise. Cette commande intelligente réduit les exigences en compétences spécialisées et améliore la stabilité et la fiabilité du processus de production.',
        },
      ],
    },
    solutions: {
      title: 'Faire entrer davantage de beaux designs dans la vie quotidienne',
      items: [
        { title: 'Tableaux décoratifs à thème culturel' },
        { title: 'Design de luminaires créatifs' },
        { title: 'Objets déco et accessoires pour la maison' },
        { title: 'Porte-crayons et boîtes de rangement pour papeterie' },
        { title: 'Accessoires au style ethnique' },
        { title: 'Souvenirs touristiques' },
      ],
    },
    bannerLeft: {
      title: 'Mettre l’éducation avec l’IA en pratique',
      subtitle:
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
    },
    learning: {
      title:
        'Outils de production en design culturel et créatif (FP supérieure)',
      groups: [
        {
          title: 'Personnalisation sur mesure',
          lines: [
            'Les découpeuses et graveuses laser permettent de personnaliser facilement des photos, des noms ou des motifs spéciaux, répondant à la demande de cadeaux uniques et mémorables.',
            'Par exemple, il est possible de graver des motifs ou du texte demandés par les clients sur des objets en bois, des accessoires en cuir ou des décorations en acrylique, pour un rendu plus personnalisé.',
          ],
        },
        {
          title: 'Fabrication de produits dérivés culturels et créatifs',
          lines: [
            'Des souvenirs de musées aux produits dérivés de films et d’animation, les découpeuses et graveuses laser rendent les designs complexes visibles et commercialisables.',
            'Elles transforment des éléments comme des sites touristiques, des monuments, des IP culturelles, etc., en produits réels : par exemple, découper une simple plaque de bois en décoration aux formes et motifs uniques, ou graver une feuille de papier ordinaire en œuvre délicate.',
          ],
        },
        {
          title: 'Création DIY',
          lines: [
            'Les équipements laser aident les passionnés à réaliser des créations DIY plus avancées : des petits objets artisanaux aux décorations uniques pour la maison, tout peut être réalisé rapidement grâce au laser.',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: 'Scène de design culturel et créatif 1' },
        { alt: 'Scène de design culturel et créatif 2' },
        { alt: 'Scène de design culturel et créatif 3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: 'Coopération éducative',
    },
    advantages: {
      title: 'Nos avantages de coopération',
      items: [
        {
          title: 'Une équipe R&D expérimentée',
          desc: 'Zhongze Education dispose d’une équipe professionnelle composée d’ingénieurs et de praticiens de l’éducation STEM, développant en continu des produits innovants conformes à des standards éducatifs élevés et attractifs pour les élèves.',
        },
        {
          title: 'IA + éducation : impulsion numérique intelligente',
          desc: 'Plateforme éducative intelligente Zhongze Education : apprentissage personnalisé, outils intelligents, expériences interactives ; prise en charge de la gestion des cours, du suivi de progression, du dépôt de devoirs, de la surveillance des équipements et de l’analyse de données. Ressources cloud riches pour un enseignement plus efficace.',
        },
        {
          title: 'Un riche système de kits et de cours',
          desc: 'Nous proposons des cours, du niveau débutant au niveau avancé, sur la découpe laser, la maison intelligente, les transports intelligents, etc., afin de répondre aux besoins d’élèves de différents âges.',
        },
      ],
    },
    modes: {
      title: 'Modes de coopération',
      carouselAlts: [
        'Scène de coopération éducative',
        'Salle de classe de coopération éducative',
        'Pratique de coopération éducative',
      ],
      items: [
        {
          title: 'Introduction de cours',
          desc: 'Les organisations partenaires peuvent adopter directement notre système de cours afin d’améliorer rapidement la qualité de l’enseignement.',
        },
        {
          title: 'Kits',
          desc: 'Les kits sont conçus spécialement pour les enfants de 3 à 16 ans. Grâce à des matériaux expérimentaux sûrs et faciles à utiliser, ils éveillent l’intérêt pour les sciences, la technologie, l’ingénierie, les arts et les mathématiques (STEAM).',
        },
        {
          title: 'Coopération produit',
          desc: 'Les organisations partenaires peuvent acquérir nos produits éducatifs, tels que des découpeuses laser, pour l’enseignement et la pratique des élèves.',
        },
        {
          title: 'R&D conjointe',
          desc: 'Nous invitons les organisations partenaires à participer au développement de cours et de produits, afin de faire progresser ensemble l’innovation éducative.',
        },
      ],
    },
    bottomBanner: {
      lines: [
        'Mettre l’éducation avec l’IA en pratique',
        'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
      ],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: 'Centre de téléchargement',
      sectionTitle: 'Téléchargement de logiciels',
      downloadButtonText: 'Télécharger le client',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: 'App de la plateforme d’apprentissage Zhongze Education' },
        { name: 'Plateforme d’apprentissage Zhongze Education' },
      ],
    },
    afterSales: {
      bannerTitle: 'Service après-vente',
      serviceTitle: 'Service intelligent AR',
      serviceItems: [
        {
          title: 'Diagnostic à distance',
          desc: 'Guidage AR à distance : l’équipe de support technique consulte l’état des équipements en temps réel, diagnostique rapidement les pannes et propose des solutions précises.',
        },
        {
          title: 'Maintenance virtuelle',
          desc: 'Démonstration d’opérations AR : présentation virtuelle des étapes de maintenance, claire et intuitive, pour vous aider à maîtriser rapidement la méthode.',
        },
        {
          title: 'Tutoriels intelligents',
          desc: 'Apprentissage interactif AR : consultez directement le guide d’utilisation sur l’équipement, efficace et pratique.',
        },
        {
          title: 'Réponse rapide',
          desc: 'Support AR instantané : réponse rapide, moins d’attente, résolution des problèmes plus efficace.',
        },
      ],
      videosTitle: 'Vidéos d’utilisation',
      playButtonText: 'Lire la vidéo',
      videos: [
        { title: 'Démonstration de déballage' },
        { title: 'Méthodes de connexion et de communication de l’équipement' },
        { title: 'Tutoriel d’utilisation Light 530' },
        { title: 'Guide d’installation (déballage)' },
        { title: 'Bases d’utilisation du logiciel' },
        { title: 'Dépannage des pannes courantes' },
      ],
      manualsTitle: 'Manuels d’utilisation',
      viewPdfButtonText: 'Voir le fichier PDF',
      manuals: [
        { title: 'Manuel d’utilisation Light 530' },
        { title: 'Manuel d’utilisation Light 640' },
        { title: 'Manuel Blue 530' },
        { title: 'Guide de maintenance M20' },
        { title: 'Manuel de sécurité de découpe laser' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: 'Trois grandes séries de kits',
      bannerDesc:
        'Les kits prennent en charge l’apprentissage personnalisé et s’adaptent aux élèves de différents âges et besoins. Ils offrent également aux enseignants des ressources et des outils pédagogiques riches, pour un enseignement et un accompagnement plus efficaces.',
      sections: {
        educationTitle: 'Kits éducatifs',
        educationDesc: 'Développer la pensée innovante et la créativité',
        creativityTitle: 'La créativité en moteur, fabriquer l’avenir',
        projectsTitle: 'Des projets éducatifs variés',
      },
      kitsTabs: [
        {
          name: 'Kit d’initiation à la découpe laser',
          title:
            'Kit d’initiation à la découpe laser\n(consommables : plaques de bois)',
          desc: 'Cours STEAM de découpe laser, conçus selon la théorie des intelligences multiples, les principes de l’éducation STEAM et l’apprentissage par projets. Destinés à différents âges, ils développent la capacité d’innovation, la pensée critique, la résolution de problèmes ainsi que la communication et l’esprit d’équipe. ',
        },
        {
          name: 'Coffret de sciences merveilleux',
          title:
            'Coffret de sciences merveilleux\n(plaques de bois + kit de micro-circuits)',
          desc: 'Les cours suivent de près les « Standards du cursus de sciences de l’enseignement obligatoire (édition 2022) ». Autour de quatre dimensions (concepts scientifiques, pensée scientifique, investigation et pratique, attitudes et responsabilité), ils développent les compétences clés des élèves. Chaque séance aboutit à une réalisation scientifique, couvrant des concepts essentiels tels que les techniques traditionnelles, l’ingénierie et la société ; elle guide les élèves à penser comme des scientifiques, renforce leur capacité d’investigation et construit une pensée scientifique solide.',
        },
        {
          name: 'Kit de programmation IA',
          title: 'Kit de programmation IA',
          desc: 'Explorez les technologies du futur en commençant par le kit de programmation IA. Les kits Ferme intelligente, Maison intelligente, Transports intelligents et Usine intelligente permettent aux élèves de découvrir l’agritech, d’expérimenter la vie moderne, d’explorer l’efficacité des transports et de comprendre la fabrication intelligente. La pratique stimule la pensée innovante, développe la résolution de problèmes et aide à se préparer au monde intelligent.',
        },
      ],
      creativityItems: [
        {
          title: 'Renforcer les compétences pratiques',
          desc: 'Ces kits intègrent l’éducation STEMA (sciences, technologie, ingénierie, arts, mathématiques). Grâce à la manipulation et aux projets, ils améliorent globalement les compétences pratiques des élèves et leur capacité à résoudre des problèmes.',
        },
        {
          title: 'Développer la pensée innovante',
          desc: 'Ils encouragent les élèves à concevoir et expérimenter de manière créative, développant pensée innovante et créativité. Les projets en équipe renforcent la communication et la coopération.',
        },
        {
          title: 'Aide à l’enseignement pour les enseignants',
          desc: 'Ils soutiennent l’enseignement par des activités de conception et d’expérimentation, développant la pensée innovante et la créativité. Les projets en équipe améliorent la communication et la coopération.',
        },
      ],
      projectItems: [
        { title: 'Sciences' },
        { title: 'Technologie' },
        { title: 'Programmation' },
        { title: 'Arts' },
      ],
      bottomBannerText:
        'Les cours renforcent les compétences pratiques et la résolution de problèmes grâce à la manipulation et aux projets ; ils développent la pensée innovante et la créativité en encourageant la conception et l’expérimentation. Les projets en équipe améliorent la communication et la coopération. Les élèves découvrent les technologies et outils les plus récents, afin de mieux s’adapter aux besoins de la société future.',
    },
    courses: {
      bannerTitle: 'Système de cours',
      bannerDesc:
        'Des cours STEAM structurés, conçus pour des élèves de différents âges, intégrant sciences, technologie, ingénierie, arts et mathématiques, afin de former les talents innovants de demain.',
      bannerAlt: 'Système de cours',
      bottomBannerAlt: 'Présentation des cours du système',
      sections: {
        kitsTitle: 'Kits de cours',
        kitsDesc: 'Combinaison parfaite de matériel et de logiciel',
        seriesTitle: 'Série de cours premium',
      },
      courseTabs: [
        {
          name: 'Âge 3–6 ans',
          title: 'Système d’exploration scientifique - maternelle (6 cours)',
          desc: 'À partir de phénomènes courants de la vie quotidienne, les élèves explorent davantage à l’aide de supports scientifiques, afin de comprendre les lois et principes du développement des choses.',
        },
        {
          name: 'Âge 6–12 ans',
          title: 'Système maker STEAM - jeunes (3 cours)',
          desc: 'Exprimer sa créativité, utiliser les équipements et pratiquer pour transformer des idées en réalisations.',
        },
        {
          name: 'Âge 8–13 ans',
          title: 'Système de cours de découpe laser (3 cours)',
          desc: 'Utiliser les équipements pour découper différents éléments structurels, les assembler en structures 3D et les embellir. Compétences en programmation : comprendre la logique et les principes des conditions en programmation.',
        },
        {
          name: 'Âge 6–15 ans',
          title: 'Système de cours d’intelligence artificielle (4 cours)',
          desc: 'Utiliser des outils et équipements pour concevoir l’apparence des réalisations, puis les rendre intelligentes et simples grâce à la programmation, afin de résoudre des problèmes du quotidien. Compétences en programmation : comprendre la logique et les principes des conditions, apprendre la syntaxe de programmation Arduino.',
        },
      ],
      introItems: [
        {
          title: 'Forte dimension pratique',
          desc: 'Les cours mettent l’accent sur la pratique : les élèves manipulent des découpeuses laser et d’autres équipements pour transformer la théorie en compétences opérationnelles.',
        },
        {
          title: 'Développement de la pensée innovante',
          desc: 'Les cours encouragent la conception et la réalisation créatives, développant la pensée innovante et la capacité à résoudre des problèmes.',
        },
        {
          title: 'Apprentissage par projets',
          desc: 'L’apprentissage est guidé par des projets : en réalisant des tâches concrètes, les élèves apprennent et maîtrisent les connaissances par la pratique.',
        },
        {
          title: 'Exploration des technologies de pointe',
          desc: 'Grâce à l’apprentissage par projets, les élèves apprennent par la pratique lors de tâches concrètes et consolident leurs connaissances.',
        },
        {
          title: 'Enseignement structuré',
          desc: 'Les cours progressent du niveau débutant au niveau intermédiaire, enseignant de manière structurée la découpe laser pour aider les élèves à construire une base solide.',
        },
        {
          title: 'Ludique et stimulant',
          desc: 'La conception des cours est à la fois ludique et exigeante, stimulant l’intérêt des élèves et leur envie d’explorer.',
        },
      ],
      courseListRow1: [
        { name: 'Ferme intelligente' },
        { name: 'Maison intelligente' },
      ],
      courseListRow2: [
        { name: 'Transports intelligents' },
        { name: 'Usine intelligente' },
      ],
      bottomBannerText:
        'Les cours se distinguent par la pratique, la pensée innovante et l’intégration interdisciplinaire. Grâce à l’apprentissage par projets, les élèves maîtrisent des technologies de pointe dans un cadre à la fois ludique et stimulant. En combinant enseignement structuré, éducation à la sécurité et apprentissage personnalisé, ils développent la dextérité, l’esprit d’équipe et la résolution de problèmes, encouragent la présentation des réalisations et renforcent le sentiment d’accomplissement.',
    },
    kitsAccessories: {
      bannerTitle: 'Accessoires pour kits',
      accessories: [
        { name: 'Bande lumineuse RGB' },
        { name: 'Module horloge DS1307' },
        { name: 'Capteur température/humidité DHT11' },
        { name: 'Capteur de présence (PIR)' },
        { name: 'Module d’éclairage LED' },
        { name: 'Module ventilateur' },
        { name: 'Interrupteur optocoupleur à fente' },
        { name: 'Module bouton' },
        { name: 'Carte de contrôle' },
        { name: 'Carte d’extension' },
        { name: 'Capteur de pluie' },
        { name: 'Moteur TT avec carte adaptatrice' },
        { name: 'Module capteur infrarouge' },
        { name: 'Télécommande infrarouge' },
        { name: 'Gaz' },
        { name: 'Module afficheur 7 segments 4 chiffres' },
        { name: 'Clavier matriciel' },
        { name: 'Capteur de luminosité' },
        { name: 'Module feu tricolore' },
        { name: 'Buzzer' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: 'Machine intelligente de découpe & gravure laser de bureau',
      sections: {
        advantages: 'Nos avantages',
        aiTitle: 'Mettre l’éducation avec l’IA en pratique',
        aiSubtitle:
          'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
        carouselTitle: 'Des possibilités infinies gravées par la lumière',
        specsTitle: 'Spécifications du produit',
      },
      bannerFeatures: [
        'Prise de vue ciblée / Tracé de contours / Protection de sécurité',
        'Conçu spécialement pour l’éducation STEAM et les makers',
      ],
      softwareSection: {
        title: 'Système de découpe laser simple à utiliser et puissant',
        items: [
          'Définissez des paramètres de procédé différents selon les matériaux : découpe, gravure profonde, gravure légère, balayage, etc.',
          'Une bibliothèque riche de modèles améliore l’efficacité de conception.',
          'La caméra prend en charge la prise de vue ciblée et l’assistance au dessin, pour concrétiser vos idées.',
        ],
      },
      advantages: [
        {
          tagTitle: 'Laser de haute qualité et haute précision',
          desc: 'Par exemple, un tube laser CO₂ en verre d’origine importée, longueur d’onde 10640nm, offrant une puissance laser continue de 50W. L’épaisseur de découpe maximale peut atteindre 15mm (acrylique). La vitesse de travail atteint 1000mm/s, avec une précision de repositionnement de 0.025mm. Cela garantit une grande précision et permet de découper et graver rapidement des créations délicates.',
        },
        {
          tagTitle: 'Système intégré de filtration des fumées à triple niveau',
          desc: 'Structure intégrée combinant filtre, charbon actif et couche UV/ozone pour filtrer les fumées. Plus propre et plus écologique, elle rend aussi l’installation plus pratique et compacte : pas besoin d’acheter un caisson de filtration séparé ni d’occuper davantage d’espace.',
        },
        {
          tagTitle: 'Sécurité au plus haut niveau',
          desc: 'A passé les tests de sécurité les plus stricts en laboratoire SGS. Produit laser de classe I certifié FDA, avec un indicateur unique de sécurité et d’état de fonctionnement, permettant de visualiser clairement l’état de la machine.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: 'Type de laser', value: 'Tube laser CO₂ en verre scellé' },
          { label: 'Course de levage de la tête laser', value: '≤25mm' },
          { label: 'Épaisseur de matériau admissible', value: '≤22mm' },
          {
            label: 'Mode de mise au point',
            value: 'Mise au point automatique, mise au point manuelle',
          },
          {
            label: 'Connectivité',
            value: 'Prise en charge USB, Ethernet et Wi‑Fi',
          },
          {
            label: 'Systèmes d’exploitation pris en charge',
            value: 'Windows, iOS',
          },
          {
            label: 'Logiciels de conception pris en charge',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
          {
            label: 'Formats de fichiers pris en charge',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG, etc.',
          },
          { label: 'Durée de vie du laser', value: '≤ 9000 h' },
          {
            label: 'Logiciels',
            value: 'LightMaker (PC et mobile), Lightburn (PC)',
          },
          {
            label: 'Modes de contrôle',
            value: 'Écran tactile LCD 5" / application mobile / logiciel PC',
          },
          { label: 'Bruit en fonctionnement', value: '≤60 dB' },
          {
            label: 'Transmission',
            value:
              'Moteur pas à pas haute vitesse + rail linéaire de haute précision + courroie synchrone',
          },
          {
            label: 'Sécurité',
            value:
              'Interverrouillage (arrêt à l’ouverture), arrêt en cas de choc, bouton d’arrêt d’urgence, clé de sécurité, indicateur d’état de fonctionnement, alarme de surchauffe du réservoir d’eau',
          },
          { label: 'Alimentation', value: '230V/110VAC 50HZ/60HZ' },
          { label: 'Poids de la machine', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          {
            label: 'Mode de refroidissement',
            value: 'Système de refroidissement par eau intégré (eau active)',
          },
          {
            label: 'Tension de fonctionnement',
            value: 'CC 24V, refroidissement par air + serpentin en aluminium',
          },
          { label: 'Capacité du réservoir', value: '3.2L' },
          { label: 'Hauteur manométrique max.', value: '5M' },
          {
            label: 'Débit d’eau',
            value:
              '1000L/H ou refroidisseur à eau laser externe dédié modèle CW3000 (optionnel)',
          },
        ],
        airPumpSpecs: [
          { label: 'Débit d’air', value: '50L/min' },
          { label: 'Bruit', value: '≤48dB' },
          { label: 'Pression', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: 'Puissance nominale', value: '62W' },
          { label: 'Débit d’air', value: '280m³/H' },
          { label: 'Bruit', value: '≤50dB' },
          { label: 'Tension', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle:
            'Paramètres du système de refroidissement par eau (intégré)',
          airPumpTitle: 'Paramètres de la pompe à air (intégrée)',
          airPumpValueOnly: 'CA 220V/110V 16W',
          exhaustTitle:
            'Paramètres du système d’extraction (unité externe intégrée), extraction latérale inférieure',
          filterTitle: 'Système de filtration',
          filterValue:
            'Coton filtrant au charbon actif + ventilateur silencieux + plaque de charbon actif industriel',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle:
        'Machine intelligente de découpe & gravure laser à lumière bleue',
      sections: {
        advantages: 'Nos avantages',
        aiTitle: 'Mettre l’éducation avec l’IA en pratique',
        aiSubtitle:
          'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
        carouselTitle: 'Des possibilités infinies gravées par la lumière',
        specsTitle: 'Spécifications du produit',
      },
      bannerFeatures: [
        'Compatible avec de nombreux matériaux',
        'Créez en toute confiance, facilement à tout moment',
      ],
      advantages: [
        {
          tagTitle: 'Design compact',
          desc: 'La graveuse à lumière bleue adopte un design élégant, moderne et compact, adapté à la maison, à l’école ou à l’atelier. La combinaison subtile d’un châssis métallique et d’un capot en acrylique vous permet d’observer clairement le processus de traitement.',
        },
        {
          tagTitle: 'Usinage fermé, isolation pour éviter les blessures',
          desc: 'La graveuse à lumière bleue est entièrement fermée : si vous ouvrez le capot pendant l’exécution, elle se met automatiquement en pause. En cas d’urgence, un seul interrupteur permet d’arrêter immédiatement la machine. Idéale pour la maison et l’école.',
        },
        {
          tagTitle:
            'Traitement multi-matériaux, compatible avec des centaines de matériaux',
          desc: 'Personnalisez une gamme de produits dynamique aux formes et styles uniques. Ajoutez des accessoires pour graver davantage de formes de matériaux, comme des mugs et des objets cylindriques, parfaitement adaptés aux besoins des petites entreprises.',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: 'Système de refroidissement',
          airPumpTitle: 'Paramètres de la pompe à air',
          airPumpValueOnly: '—',
          exhaustTitle: 'Système d’extraction',
          filterTitle: 'Système de filtration',
          filterValue: '—',
        },
        left: [
          {
            key: 'laserType',
            label: 'Type de laser',
            value: 'Laser à lumière bleue',
          },
          {
            key: 'laserPower',
            label: 'Puissance du laser',
            value: '20W / 40W',
          },
          {
            key: 'maxCutThickness',
            label: 'Épaisseur de découpe max.',
            value: '≤10mm',
          },
          {
            key: 'focusMode',
            label: 'Mode de mise au point',
            value: 'Mise au point manuelle',
          },
          { key: 'connection', label: 'Connectivité', value: 'Connexion USB' },
          {
            key: 'os',
            label: 'Systèmes d’exploitation pris en charge',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: 'Logiciel',
            value: 'LightBurn (PC)',
          },
          {
            key: 'laserLifetime',
            label: 'Durée de vie du laser',
            value: '≥10000 h',
          },
          {
            key: 'maxMaterialThickness',
            label: 'Épaisseur de matériau admissible',
            value: '15mm',
          },
          { key: 'noise', label: 'Bruit en fonctionnement', value: '≤60dB' },
          {
            key: 'engraveSpeed',
            label: 'Vitesse de gravure',
            value: '600mm/s',
          },
          {
            key: 'designSoftware',
            label: 'Logiciels de conception pris en charge',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks, etc.',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'maxSpeed',
            label: 'Vitesse de travail max.',
            value: '1000mm/s',
          },
          {
            key: 'power',
            label: 'Alimentation',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'workTable',
            label: 'Dimensions du plateau de travail',
            value: '520 × 315mm',
          },
          {
            key: 'accuracy',
            label: 'Précision de positionnement',
            value: '±0.01mm',
          },
          {
            key: 'repeatAccuracy',
            label: 'Précision de repositionnement',
            value: '±0.005mm',
          },
          {
            key: 'powerRequirement',
            label: 'Exigences d’alimentation',
            value: 'AC 220V ±10 %, 50Hz',
          },
          { key: 'totalPower', label: 'Puissance totale', value: '300W' },
          {
            key: 'transmission',
            label: 'Transmission',
            value:
              'Moteurs pas à pas haute vitesse + rails linéaires haute précision + courroie synchrone',
          },
          {
            key: 'safety',
            label: 'Sécurité',
            value:
              'Interverrouillage (arrêt à l’ouverture), limiteur d’axe, bouton d’arrêt d’urgence, clé de sécurité',
          },
          { key: 'weight', label: 'Poids de la machine', value: '≈50kg' },
          {
            key: 'machineSize',
            label: 'Dimensions de la machine',
            value: '805 × 585 × 320mm',
          },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: 'Marqueuse laser haute précision',
      sections: {
        advantages: 'Nos avantages',
        aiTitle: 'Mettre l’éducation avec l’IA en pratique',
        aiSubtitle:
          'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
        carouselTitle: 'Marquage laser, personnalisation créative',
        specsTitle: 'Spécifications du produit',
      },
      bannerFeatures: [
        'Sécurité garantie, double commande par interrupteurs, protection laser',
        'Capacités de gravure et de découpe à haute précision, haute vitesse et grande stabilité',
      ],
      advantages: [
        {
          tagTitle: 'Scénarios d’application variés',
          desc: 'Cet équipement convient à de nombreux secteurs : gravure de bijoux, objets personnalisés, identification de pièces, etc. Il répond aux besoins de gravure sur mesure, des bijoux et flacons de parfum aux petites plaques industrielles.',
        },
        {
          tagTitle: 'Applications innovantes dans l’éducation',
          desc: 'Le Mark M20 apporte une précision de niveau industriel au secteur éducatif, devenant un « assistant polyvalent » pour l’éducation scientifique et technologique, et développant chez les élèves des compétences allant du marquage de base au développement de projets complexes.',
        },
        {
          tagTitle: 'Compact et moderne',
          desc: 'La marqueuse laser Mark M20 adopte un design compact et moderne, avec une faible empreinte au sol, un bruit réduit et une grande fenêtre d’observation, répondant à des exigences élevées de durabilité. Son apparence élégante respecte les normes de sécurité et convient aux établissements éducatifs comme aux environnements de vente au détail.',
        },
        {
          tagTitle: 'Marquage en quelques secondes',
          desc: 'Même avec la plus petite police, le Mark M20 peut réaliser un marquage précis en quelques secondes. Cette vitesse inégalée, combinée au flux de travail simplifié et à l’efficacité de notre logiciel laser LightMaker, améliore considérablement votre productivité. ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: 'Type de laser', value: 'Laser à fibre' },
          {
            key: 'laserPower',
            label: 'Puissance du laser',
            value: '20W / 30W / 50W',
          },
          {
            key: 'markArea',
            label: 'Zone de marquage',
            value:
              'Standard 110×110mm (extensible en remplaçant l’objectif, par ex. 175×175mm, etc.)',
          },
          {
            key: 'maxHeight',
            label: 'Hauteur de travail max.',
            value: '≤130mm',
          },
          { key: 'connection', label: 'Connectivité', value: 'Ethernet' },
          {
            key: 'os',
            label: 'Systèmes d’exploitation pris en charge',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: 'Alimentation',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: 'Sécurité',
            value:
              'Interverrouillage (arrêt à l’ouverture), limiteur d’axe, bouton d’arrêt d’urgence, clé de sécurité',
          },
          {
            key: 'software',
            label: 'Logiciel pris en charge',
            value: 'Mantimark',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: 'Transmission',
            value:
              'Levage du module de marquage par vis motorisée de haute précision',
          },
          {
            key: 'fileFormat',
            label: 'Fichiers pris en charge',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          {
            key: 'spotSize',
            label: 'Diamètre du spot focalisé',
            value: '≤20μm',
          },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: 'Machine intelligente de découpe & gravure laser sur table',
      sections: {
        advantages: 'Nos avantages',
        aiTitle: 'Mettre l’éducation avec l’IA en pratique',
        aiSubtitle:
          'IA+éducation : impulsion numérique intelligente et intégration d’idées innovantes',
        carouselTitle: 'Découpe créative, commencez ici',
        specsTitle: 'Spécifications du produit',
      },
      bannerFeatures: [
        'Rapide / Porte arrière ouverte / Mise au point automatique efficace',
        'Découpeuse-graveuse laser tout-en-un',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: 'Zone de travail',
          desc: 'Excellents résultats de découpe et de gravure, plusieurs modèles et configurations de puissance laser pour répondre à différents besoins.\nType de laser : CO2 CC\nPuissance laser : 60W-130W\nLight640 (600*400mm)\nLight960 (900*600mm)\nLight1390 (1300*900mm)\nLight1610 (1600*1000mm)',
        },
        {
          tagTitle:
            'Mise au point automatique efficace + positionnement par point rouge',
          desc: 'La mise au point automatique permet un réglage et un positionnement rapides et précis avant la découpe et la gravure. Associée au faisceau de point rouge, elle permet de visualiser en temps réel la position de travail. Vous gagnez ainsi du temps et obtenez de meilleurs résultats de découpe et de gravure.',
        },
        {
          tagTitle: 'Conception à porte arrière ouverte',
          desc: 'La porte arrière ouverte permet d’insérer des matériaux de découpe et de gravure de longueur illimitée. Les plaques de 600mm×∞ rendent le travail plus pratique et réduisent les contraintes.',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: 'Excellents résultats de découpe et de gravure',
            desc: 'La découpeuse laser est équipée d’une plateforme de découpe haute précision. Le traitement de matériaux tels que le bois et l’acrylique atteint des standards et une efficacité de niveau industriel, permettant la production en série de produits artisanaux au laser et améliorant fortement la productivité et la valeur de marque.',
          },
          {
            tagTitle: 'Tube laser de qualité et composants de précision',
            desc: 'Une gamme de produits diversifiée permet de choisir différents types de laser et intensités d’usinage selon les besoins, répondant à divers scénarios de production et élargissant les applications sur le bois, le verre, l’acrylique, etc.',
          },
          {
            tagTitle: 'Tests qualité rigoureux, garantie de qualité',
            desc: 'Des tests stricts en production, un contrôle optique précis et plus de 5 tests de découpe et de gravure garantissent un tube laser CO2 haut de gamme à sortie stable et constante. Grâce à une excellente stabilité de puissance et à un spot laser fin, la gravure est uniforme et permet même des détails complexes.',
          },
        ],
        light1390: [
          {
            tagTitle: 'Excellents résultats de découpe et de gravure',
            desc: 'La découpeuse laser est équipée d’une plateforme de découpe haute précision. Le traitement de matériaux tels que le bois et l’acrylique atteint des standards et une efficacité de niveau industriel, permettant la production en série de produits artisanaux au laser et améliorant fortement la productivité et la valeur de marque.',
          },
          {
            tagTitle: 'Tube laser de qualité et composants de précision',
            desc: 'Une gamme de produits diversifiée permet de choisir différents types de laser et intensités d’usinage selon les besoins, répondant à divers scénarios de production et élargissant les applications sur le bois, le verre, l’acrylique, etc.',
          },
          {
            tagTitle: 'Tests qualité rigoureux, garantie de qualité',
            desc: 'Des tests stricts en production, un contrôle optique précis et plus de 5 tests de découpe et de gravure garantissent un tube laser CO2 haut de gamme à sortie stable et constante. Grâce à une excellente stabilité de puissance et à un spot laser fin, la gravure est uniforme et permet même des détails complexes.',
          },
        ],
        light1610: [
          {
            tagTitle: 'Fonctions de sécurité complètes et avancées',
            desc: '1. Arrêt d’urgence\n2. Voyant d’alarme\n3. Interrupteur étanche\n4. Câble de mise à la terre\n5. Alarme du détecteur thermique intégré activée automatiquement en cas d’activité anormale\n6. Protection par verrouillage du capot\n7. Fenêtre de protection durable en verre trempé',
          },
          {
            tagTitle: 'Durable et d’excellente qualité',
            desc: '1. Idéal pour les projets à l’unité ou la production à grande échelle.\n2. Large choix de zones de travail, de 600 x 400MM à 1600 x 1000MM.\n3. Vitesse de gravure inégalée.\n4. Conçu par des experts du secteur.\n5. Idéal pour les applications personnalisées, éducatives et industrielles.',
          },
          {
            tagTitle:
              'Optimiser la production grâce à la surveillance intelligente',
            desc: 'Conçu pour protéger les composants les plus coûteux (axes, tête laser, éléments optiques, lentilles) contre la poussière et les saletés. Même en usage intensif, il garantit des années de fonctionnement sans panne.',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Que peut-on réaliser avec Light 640 ?',
          items: [
            {
              title: 'Light 640 - Projet 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - Projet 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - Projet 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - Projet 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - Projet 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - Projet 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - Projet 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - Projet 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Que peut-on réaliser avec Light 960 ?',
          items: [
            {
              title: 'Light 960 - Projet 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - Projet 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - Projet 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - Projet 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - Projet 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - Projet 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - Projet 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - Projet 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Que peut-on réaliser avec Light 1390 ?',
          items: [
            {
              title: 'Light 1390 - Projet 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - Projet 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - Projet 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - Projet 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - Projet 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - Projet 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - Projet 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - Projet 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Que peut-on réaliser avec Light 1610 ?',
          items: [
            {
              title: 'Light 1610 - Projet 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - Projet 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - Projet 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - Projet 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - Projet 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - Projet 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - Projet 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - Projet 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: 'Système de refroidissement',

          exhaustTitle: 'Système d’extraction',
        },
        left: [
          { key: 'model', label: 'Modèle', value: 'Light 640' },
          { key: 'workArea', label: 'Zone de travail', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: 'Type de laser',
            value: 'Tube laser CO₂ en verre scellé',
          },
          {
            key: 'laserPower',
            label: 'Puissance du laser',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Hauteur de l’axe Z',
            value: '135mm (5.3 pouces)',
          },
          {
            key: 'tableSize',
            label: 'Dimensions du plateau',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: 'Taille max. du matériau (portes avant/arrière fermées)',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: 'Taille max. du matériau (porte arrière ouverte)',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: 'Dimensions de la machine (larg. × long. × haut.)',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: 'Poids de la machine',
            value: '300kg (660 lb)',
          },
          {
            key: 'maxSpeed',
            label: 'Vitesse de travail max.',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: 'Précision de positionnement',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: 'Mode de mise au point',
            value: 'Mise au point automatique / manuelle',
          },
          {
            key: 'resume',
            label: 'Reprise après coupure de courant',
            value: 'Pris en charge',
          },
          {
            key: 'transmission',
            label: 'Transmission',
            value:
              'Moteurs pas à pas haute vitesse + moteur en boucle fermée haute précision',
          },
          {
            key: 'connection',
            label: 'Modes de connexion',
            value: 'LAN (Ethernet) / USB / Wi‑Fi',
          },
        ],
        right: [
          {
            key: 'software',
            label: 'Logiciel',
            value: 'Good-Laser LightMaker (compatible avec LightBurn)',
          },
          {
            key: 'process',
            label: 'Procédés',
            value:
              'Dessin au trait, découpe, gravure profonde, gravure superficielle',
          },
          {
            key: 'fileFormats',
            label: 'Formats de fichiers pris en charge',
            value:
              'Bitmap : JPG / PNG / BMP ; Vectoriel : LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: 'Fréquence',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: 'Phase',
            value: 'Monophasé',
          },
          {
            key: 'current',
            label: 'Courant à pleine charge',
            value: '6A',
          },
          {
            key: 'voltage',
            label: 'Tension',
            value: '230V CA',
          },
          {
            key: 'totalPower',
            label: 'Puissance totale',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: 'Matériaux compatibles',
            value:
              'Bois, acrylique, cuir, tissu, plastique, carton, caoutchouc, plaque bicolore, marbre, verre, aluminium anodisé et autres matériaux non métalliques',
          },
          {
            key: 'safety',
            label: 'Normes de sécurité',
            value:
              'Conforme aux normes de sécurité CE de l’UE, avec protection à l’ouverture de la chambre de travail, système de protection du refroidissement, système d’alarme automatique de contrôle de température, protection contre les fuites électriques, système d’arrêt d’urgence, système optique, fenêtre d’observation en verre trempé, indicateurs d’état de fonctionnement, etc.',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: 'Mode de refroidissement',
            value: 'Refroidissement par eau',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: 'Diamètre de sortie d’extraction',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: 'Tube laser CO₂ en verre scellé',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm (5.3 pouces)',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg (902 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Mise au point automatique / manuelle',
          resume: 'Pris en charge',
          transmission:
            'Moteurs pas à pas haute vitesse + moteur en boucle fermée haute précision',
          connection: 'LAN (Ethernet) / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatible avec LightBurn)',
          process:
            'Dessin au trait, découpe, gravure profonde, gravure superficielle',
          fileFormats:
            'Bitmap : JPG / PNG / BMP ; Vectoriel : LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monophasé',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Bois, acrylique, cuir, tissu, plastique, carton, caoutchouc, plaque bicolore, marbre, verre, aluminium anodisé et autres matériaux non métalliques',
          safety:
            'Conforme aux normes de sécurité CE de l’UE, avec protection à l’ouverture de la chambre de travail, système de protection du refroidissement par eau, système d’alarme automatique de contrôle de température, protection contre les fuites électriques, système d’arrêt d’urgence, système optique, fenêtre d’observation en verre trempé, indicateurs d’état de fonctionnement, etc.',
          coolingMode: 'Refroidissement par eau',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: 'Tube laser CO₂ en verre scellé',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm (5.3 pouces)',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg (1100 lb)',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Mise au point automatique / manuelle',
          resume: 'Pris en charge',
          transmission:
            'Moteurs pas à pas haute vitesse + moteur en boucle fermée haute précision',
          connection: 'LAN (Ethernet) / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatible avec LightBurn)',
          process:
            'Dessin au trait, découpe, gravure profonde, gravure superficielle',
          fileFormats:
            'Bitmap : JPG / PNG / BMP ; Vectoriel : LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monophasé',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Bois, acrylique, cuir, tissu, plastique, carton, caoutchouc, plaque bicolore, marbre, verre, aluminium anodisé et autres matériaux non métalliques',
          safety:
            'Conforme aux normes de sécurité CE de l’UE, avec protection à l’ouverture de la chambre de travail, système de protection du refroidissement par eau, système d’alarme automatique de contrôle de température, protection contre les fuites électriques, système d’arrêt d’urgence, système optique, fenêtre d’observation en verre trempé, indicateurs d’état de fonctionnement, etc.',
          coolingMode: 'Refroidissement par eau',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: 'Tube laser CO₂ en verre scellé',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm (5.3 pouces)',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg (1298 lb)',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: 'Mise au point automatique / manuelle',
          resume: 'Pris en charge',
          transmission:
            'Moteurs pas à pas haute vitesse + moteur en boucle fermée haute précision',
          connection: 'LAN (Ethernet) / USB / Wi‑Fi',
          software: 'Good-Laser LightMaker (compatible avec LightBurn)',
          process:
            'Dessin au trait, découpe, gravure profonde, gravure superficielle',
          fileFormats:
            'Bitmap : JPG / PNG / BMP ; Vectoriel : LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: 'Monophasé',
          current: '6A',
          voltage: '230V CA',
          totalPower: '≤ 1.5kW',
          materials:
            'Bois, acrylique, cuir, tissu, plastique, carton, caoutchouc, plaque bicolore, marbre, verre, aluminium anodisé et autres matériaux non métalliques',
          safety:
            'Entièrement conforme aux normes de sécurité CE de l’UE, avec protection à l’ouverture, protection du refroidissement par eau, alarme de température, protection contre les fuites électriques, arrêt d’urgence et système d’interverrouillage laser',
          coolingMode: 'Refroidissement par eau',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: 'Votre adresse e-mail',
      button: 'S’abonner',
    },
    social: {
      tiktok: 'TikTok',
      weibo: 'WeChat Channels',
      wechat: 'WeChat',
      redbook: 'Xiaohongshu (RED)',
    },
    companyDesc:
      'Spécialisée dans l’éducation à la créativité scientifique et technologique pour les enfants et adolescents de 3 à 16 ans, l’entreprise déploie des espaces maker, développe en interne des produits et des cours d’éducation scientifique et technologique, autour de modules tels que les logiciels de conception pour l’apprentissage, la gravure laser et la programmation.',
    navColumns: [
      {
        title: 'Produits',
        items: [
          { label: 'Équipements', to: '/product/light530' },
          { label: 'Kits', to: '/product/kits' },
          { label: 'Cours', to: '/product/courses' },
        ],
      },
      {
        title: 'Logiciels',
        items: [
          {
            label: 'Plateforme cloud Zhongze Education',
            to: '/software/cloud-platform',
          },
          {
            label: 'Plateforme d’apprentissage Zhongze Education',
            to: '/software/learning-platform',
          },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: 'Services éducatifs',
        items: [
          { label: 'Solution éducative IA', to: '/edu-services' },
          {
            label: 'Maker éducatif - Primaire et secondaire',
            to: '/edu-services/maker-k12',
          },
          {
            label: 'Maquettes architecturales - Formation professionnelle',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: 'Design culturel et créatif - FP supérieure',
            to: '/edu-services/cultural-higher-vocational',
          },
          {
            label: 'Arts et artisanat - Universités',
            to: '/edu-services/arts-university',
          },
          { label: 'Espace d’innovation', to: '/edu-services' },
        ],
      },
      {
        title: 'Service et support',
        items: [
          { label: 'Centre de téléchargement', to: '/support/download' },
          { label: 'Service après-vente', to: '/support/after-sales' },
        ],
      },
      {
        title: 'Coopération éducative',
        items: [
          { label: 'Coopération éducative', to: '/edu-services/cooperation' },
        ],
      },
      {
        title: 'À propos de nous',
        items: [
          { label: 'À propos de nous', to: '/about' },
          { label: 'Actualités', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: 'Ligne commerciale : 18379276683',
      email: 'E-mail : sam@zz-steam.com',
      address:
        'Adresse : Tour A, immeuble Huashengda, 4e route Bagua, district de Futian, Shenzhen',
    },
    qrDesc: 'En savoir plus',
  },

  globalContactForm: {
    title: 'Nous contacter',
    subtitle:
      'Veuillez remplir le formulaire ci-dessous, nous vous contacterons rapidement',
    fields: {
      name: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      company: 'Entreprise',
      message: 'Message',
    },
    placeholders: {
      name: 'Veuillez saisir votre nom',
      email: 'Veuillez saisir votre e-mail',
      phone: 'Veuillez saisir votre téléphone',
      company: 'Veuillez saisir le nom de votre entreprise',
      message: 'Veuillez saisir votre message',
    },
    submitting: 'Envoi en cours...',
    submit: 'Envoyer',
    visual: {
      title: 'Au plaisir de collaborer avec vous',
      description:
        'Nous offrons des services et un support professionnels ; n’hésitez pas à nous contacter en cas de questions.',
    },
    contact: {
      phone: 'Téléphone',
      email: 'E-mail',
    },
    validation: {
      name: 'Veuillez saisir votre nom',
      email: 'Veuillez saisir votre e-mail',
      emailFormat: 'Veuillez saisir une adresse e-mail valide',
      phone: 'Veuillez saisir votre numéro de téléphone',
      phoneFormat: 'Veuillez saisir un numéro de téléphone valide',
      message: 'Veuillez saisir votre message',
    },
    success: 'Envoi réussi ! Nous vous contacterons rapidement.',
    networkError: 'Échec de l’envoi, veuillez réessayer plus tard.',
  },
};
